import { LoadAswMasterInfo } from '@lib/interfaces';

/**
 * チェックイン系で読み込むマスター一覧
 */
type MasterKeys =
  // | 'AIRLINE_BY_AIRLINE_CODE'
  | 'AIRPORT_I18NJOIN_BY_AIRPORT_CODE'
  // | 'EQUIPMENT_BY_ACV'
  // | 'COUNTRY_BY_COUNTRY_2_LETTER_CODE'
  // | 'COUNTRY_BY_COUNTRY_3_LETTER_CODE'
  // | 'MILEAGE_PROGRAM_BY_CARRIER_CODE'
  // | 'STATE_BY_STATE_CODE'
  // | 'CABIN_BY_CABIN_CODE'
  // | 'FUNCTION_INELIGIBLE_REASON'
  | 'GENDER_BY_GENDER'
  | 'LANG_CODE_CONVERT_BY_LANG'
  // | 'POS_BY_COUNTRY_2_LETTER_CODE'
  // | 'POS_COUNTRY_ALL'
  // | 'POS_COUNTRY_ALL_SMS'
  | 'COUNTRY_COUNTRYI18N_ALL'
  // | 'AIRCRAFT_CABIN_BY_ACV_AND_CABIN'
  | 'SUPPORT_LIST'
  | 'LISTDATA_960LIST'
  | 'LISTDATA_022LIST'
  | 'LISTDATA_011LIST'
  | 'BASIC_HOTEL_DISTRICT_I18N_LIST'
  | 'BASIC_HOTEL_REGION_I18N_LIST'
  | 'BASIC_HOTEL_AREA_I18N_LIST'
  | 'CHARGEABLE_SERVICE_ALL'
  | 'CHARGEABLE_SERVICE_SSR_ALL'
  | 'BANK_LANG'
  | 'LISTDATA_ALL'
  | 'M_OFFICE'
  | 'M_NDC_OFFICE'
  | 'M_PAYMENT_INFORMATION'
  | 'M_OLD_AND_NEW_ERROR_MAPPING'
  | 'M_MILEAGE_PROGRAM_I18N'
  | 'M_AWARD_CAMPAIGN'
  | 'SERVICE_CONTENTS_BY_ITINERARY_TYPE_CABIN'
  | 'M_PAYMENT_ERROR'
  | 'M_PREORDER_MEAL_FLIGHT'
  | 'M_FARE_FULL_RULE'
  | 'AIRLINE_I18NJOIN_BY_AIRLINE_CODE'
  // 提携: AirCraftCabin_ACVandCabinからAirCraftCabin_I18nJoin_ACVandCabinを使用するように修正。
  // | 'AIRCRAFT_CABIN_ACV_AND_CABIN'
  | 'AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN'
  | 'M_LIST_DATA_930'
  | 'AIRLINE_I18N_ALL'
  | 'AIRPORT_I18N_ALL'
  // 提携: Equipment_PkからEquipment_I18nJoin_Pkを使用するように修正。
  // | 'EQUIPMENT_PK'
  | 'EQUIPMENT_I18NJOIN_PK'
  | 'FF_PRIORITY_CODE_I18N_ALL'
  | 'COUNTRY_I18N_BY_2LETTERCODE'
  | 'AIRCRAFT_CABIN_ALL'
  | 'COUNTRY_I18N_POS_COUNTRY'
  | 'POS_COUNTRY_ALL'
  | 'FUNCTION_INELIGIBLE_REASON_PK'
  | 'TAX_ALL_LANG'
  | 'COUNTRY_COUNTRYI18N_LISTDATA'
  | 'M_SPECIAL_MEAL'
  | 'OFFICE_BY_OFFICE_CODE'
  | 'BANK_ALL'
  | 'OFFLINEOFFICE_CITYCODE';

/**
 * チェックイン系で読み込むマスターの一覧オブジェクト
 */
export const LOAD_MASTERS: Record<MasterKeys, LoadAswMasterInfo> = {
  // AIRLINE_BY_AIRLINE_CODE: {
  //   key: 'airlineByAirlineCode',
  //   fileName: 'Airline_ByAirlineCodeNgx',
  //   isCurrentLang: true,
  // },
  AIRPORT_I18NJOIN_BY_AIRPORT_CODE: {
    key: 'airportI18nJoinByAirportCode',
    fileName: 'Airport_I18nJoin_ByAirportCode',
    isCurrentLang: true,
  },
  // EQUIPMENT_BY_ACV: {
  //   key: 'equipmentByAcv',
  //   fileName: 'Equipment_ByAcv',
  // },
  // COUNTRY_BY_COUNTRY_2_LETTER_CODE: {
  //   key: 'countryByCountry2LetterCodeI18n',
  //   fileName: 'Country_ByCountry2letterCodeNgx',
  //   isCurrentLang: true,
  // },
  // COUNTRY_BY_COUNTRY_3_LETTER_CODE: {
  //   key: 'countryByCountry3LetterCodeI18n',
  //   fileName: 'Country_ByCountry3letterCodeNgx',
  //   isCurrentLang: true,
  // },
  // MILEAGE_PROGRAM_BY_CARRIER_CODE: {
  //   key: 'mileageProgramI18nByCarrierCode',
  //   fileName: 'Mileage_Program_I18n_ByCarrierCodeNgx',
  //   isCurrentLang: true,
  // },
  // STATE_BY_STATE_CODE: {
  //   key: 'stateByStateCode',
  //   fileName: 'State_ByStateCodeNgx',
  //   isCurrentLang: true,
  // },
  // CABIN_BY_CABIN_CODE: {
  //   key: 'cabinByCabinCode',
  //   fileName: 'Cabin_ByCabinCodeNgx',
  //   isCurrentLang: true,
  // },
  // FUNCTION_INELIGIBLE_REASON: {
  //   key: 'functionIneligibleReason',
  //   fileName: 'FunctionIneligibleReason',
  // },
  GENDER_BY_GENDER: {
    key: 'genderByGender',
    fileName: 'Gender_ByGender',
    isCurrentLang: true,
  },
  LANG_CODE_CONVERT_BY_LANG: {
    key: 'langCodeConvertByLang',
    fileName: 'LangCodeConvert_ByLang',
    isCurrentLang: false,
  },
  // POS_BY_COUNTRY_2_LETTER_CODE: {
  //   key: 'posByCountry2LetterCode',
  //   fileName: 'Pos_ByCountry2LetterCode',
  // },
  // POS_COUNTRY_ALL: {
  //   key: 'posCountryAll',
  //   fileName: 'PosCountry_All',
  //   isCurrentLang: true,
  // },
  // POS_COUNTRY_ALL_SMS: {
  //   key: 'countryWithPosCountryForSmsSendTelNumber',
  //   fileName: 'Country_WithPosCountryForSmsSendTelNumber',
  //   isCurrentLang: true,
  // },
  COUNTRY_COUNTRYI18N_ALL: {
    key: 'countryCountryI18nAll',
    fileName: 'Country_CountryI18n_All',
    isCurrentLang: true,
  },
  // AIRCRAFT_CABIN_BY_ACV_AND_CABIN: {
  //   key: 'AircraftCabin_ByAcvAndCabin',
  //   fileName: 'AircraftCabin_ByAcvAndCabin',
  // },
  SUPPORT_LIST: {
    key: 'supportList',
    fileName: 'Support_List',
    isCurrentLang: true,
  },
  LISTDATA_960LIST: {
    key: 'listData960List',
    fileName: 'ListData_960List',
    isCurrentLang: true,
  },
  LISTDATA_022LIST: {
    key: 'listData022List',
    fileName: 'ListData_022List',
    isCurrentLang: true,
  },
  LISTDATA_011LIST: {
    key: 'listData011List',
    fileName: 'ListData_011List',
    isCurrentLang: true,
  },
  BASIC_HOTEL_DISTRICT_I18N_LIST: {
    key: 'basicHotelDistrictI18nList',
    fileName: 'BasicHotelDistrictI18n_List',
    isCurrentLang: true,
  },
  BASIC_HOTEL_REGION_I18N_LIST: {
    key: 'basicHotelRegionI18nList',
    fileName: 'BasicHotelRegionI18n_List',
    isCurrentLang: true,
  },
  BASIC_HOTEL_AREA_I18N_LIST: {
    key: 'basicHotelAreaI18nList',
    fileName: 'BasicHotelAreaI18n_List',
    isCurrentLang: true,
  },
  CHARGEABLE_SERVICE_SSR_ALL: {
    key: 'ChargeableServiceSsr_All',
    fileName: 'ChargeableServiceSsr_All',
  },
  CHARGEABLE_SERVICE_ALL: {
    key: 'ChargeableService_All',
    fileName: 'ChargeableService_All',
  },
  BANK_LANG: {
    key: 'Bank_Lang',
    fileName: 'Bank_Lang',
  },
  LISTDATA_ALL: {
    key: 'ListData_All',
    fileName: 'ListData_All',
  },
  M_OFFICE: {
    key: 'Office_All',
    fileName: 'Office_All',
  },
  M_NDC_OFFICE: {
    key: 'Ndc_OfficeCode_All',
    fileName: 'Ndc_OfficeCode_All',
  },
  M_PAYMENT_INFORMATION: {
    key: 'PaymentInformation_All',
    fileName: 'PaymentInformation_All',
  },
  M_OLD_AND_NEW_ERROR_MAPPING: {
    key: 'OldAndNewErrorMapping',
    fileName: 'OldAndNewErrorMapping',
  },
  M_MILEAGE_PROGRAM_I18N: {
    key: 'm_mileage_program_i18n_all',
    fileName: 'm_mileage_program_i18n_all',
    isCurrentLang: true,
  },
  M_AWARD_CAMPAIGN: {
    key: 'AwardCampaign_All',
    fileName: 'AwardCampaign_All',
  },
  SERVICE_CONTENTS_BY_ITINERARY_TYPE_CABIN: {
    key: 'ServiceContentsByItineraryType_Cabin',
    fileName: 'ServiceContentsByItineraryType_Cabin',
    isCurrentLang: true,
  },
  M_FARE_FULL_RULE: {
    key: 'FareFullRule_All',
    fileName: 'FareFullRule_All',
  },
  M_PAYMENT_ERROR: {
    key: 'PaymentError_All',
    fileName: 'PaymentError_All',
  },
  M_PREORDER_MEAL_FLIGHT: {
    key: 'Preorder_Meal_Flight_All',
    fileName: 'Preorder_Meal_Flight_All',
  },
  AIRLINE_I18NJOIN_BY_AIRLINE_CODE: {
    key: 'airlineI18nJoinByAirlineCode',
    fileName: 'Airline_I18nJoin_ByAirlineCode',
    isCurrentLang: true,
  },
  // 提携: AirCraftCabin_ACVandCabinからAirCraftCabin_I18nJoin_ACVandCabinを使用するように修正。
  // AIRCRAFT_CABIN_ACV_AND_CABIN: {
  //   key: 'AirCraftCabin_ACVandCabin',
  //   fileName: 'AirCraftCabin_ACVandCabin',
  // },
  AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN: {
    key: 'AirCraftCabin_I18nJoin_ACVandCabin',
    fileName: 'AirCraftCabin_I18nJoin_ACVandCabin',
    isCurrentLang: true,
  },
  M_LIST_DATA_930: {
    key: 'm_list_data_930',
    fileName: 'm_list_data_930/M_list_data_930',
    isCurrentLang: true,
  },
  AIRLINE_I18N_ALL: {
    key: 'Airline_I18nJoinAll',
    fileName: 'Airline_I18nJoinAll',
    isCurrentLang: true,
  },
  AIRPORT_I18N_ALL: {
    key: 'AirportI18n_SearchForAirportCode',
    fileName: 'AirportI18n_SearchForAirportCode',
    isCurrentLang: true,
  },
  // 提携: Equipment_PkからEquipment_I18nJoin_Pkを使用するように修正。
  // EQUIPMENT_PK: {
  //   key: 'Equipment_Pk',
  //   fileName: 'Equipment_Pk',
  // },
  EQUIPMENT_I18NJOIN_PK: {
    key: 'Equipment_I18nJoin_Pk',
    fileName: 'Equipment_I18nJoin_Pk',
    isCurrentLang: true,
  },
  FF_PRIORITY_CODE_I18N_ALL: {
    key: 'FFPriorityCode_Lang',
    fileName: 'FFPriorityCode_Lang',
    isCurrentLang: true,
  },
  COUNTRY_I18N_BY_2LETTERCODE: {
    key: 'Country_I18nJoin_ByCountry2letterCode',
    fileName: 'Country_I18nJoin_ByCountry2letterCode',
    isCurrentLang: true,
  },
  AIRCRAFT_CABIN_ALL: {
    key: 'AircraftCabin_All',
    fileName: 'AircraftCabin_All',
  },
  COUNTRY_I18N_POS_COUNTRY: {
    key: 'Country_CountryI18n_PosCountry',
    fileName: 'Country_CountryI18n_PosCountry',
    isCurrentLang: true,
  },
  POS_COUNTRY_ALL: {
    key: 'PosCountry_PrimaryCountry',
    fileName: 'PosCountry_PrimaryCountry',
  },
  FUNCTION_INELIGIBLE_REASON_PK: {
    key: 'FunctionIneligibleReason_ByPk',
    fileName: 'FunctionIneligibleReason_ByPk',
  },
  TAX_ALL_LANG: {
    key: 'Tax_All_Lang',
    fileName: 'Tax_All_Lang',
  },
  COUNTRY_COUNTRYI18N_LISTDATA: {
    key: 'Country_CountryI18n_ListData',
    fileName: 'Country_CountryI18n_ListData',
    isCurrentLang: true,
  },
  OFFLINEOFFICE_CITYCODE: {
    key: 'OfflineOffice_CityCode',
    fileName: 'OfflineOffice_CityCode',
    isCurrentLang: false,
  },
  M_SPECIAL_MEAL: {
    key: 'M_SPECIAL_MEAL',
    fileName: 'M_SPECIAL_MEAL',
    isCurrentLang: true,
  },
  OFFICE_BY_OFFICE_CODE: {
    key: 'Office_ByOffceCode',
    fileName: 'Office_ByOffceCode',
  },
  BANK_ALL: {
    key: 'Bank_All',
    fileName: 'Bank_All',
  },
};

/** 文言キーprefix */
export const TranslatePrefix = {
  AIRLINE: 'm_airline_i18n_',
} as const;

/**
 * マスターを読み込んだ際にそのデータにつけるキー
 */
export const MASTER_KEY = {
  AIRLINE_BY_AIRLINE_CODE: 'airlineByAirlineCode',
  AIRPORT_BY_AIRPORT_CODE: 'airportByAirportCode',
  // 提携: AirCraftCabin_ACVandCabinからAirCraftCabin_I18nJoin_ACVandCabinを使用するように修正。
  // AIRCRAFT_CABIN_ACV_AND_CABIN: 'AirCraftCabin_ACVandCabin',
  AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN: 'AirCraftCabin_I18nJoin_ACVandCabin',
} as const;
